import React from "react";
import "./secondarySectionStyle.scss";

const SecondarySection = ({ children, className }) => {
  return <div className={`secondary-container ${className}`}>{children}</div>;
};

export default SecondarySection;
